module.exports = __webpack_public_path__ + "img/mv.44a3b21f.svg";